const state = {
    showGenericModal: false,
    genericModalText: "",
};

const mutations = {
    SET_SHOW_GENERIC_MODAL: (state, showGenericModal) => {
        state.showGenericModal = showGenericModal;
    },
    SET_GENERIC_MODAL: (state, genericModalText) => {
        state.genericModalText = genericModalText;
        state.showGenericModal = true;
    },
};

const getters = {
    showGenericModal: (state) => state.showGenericModal,
    genericModalText: (state) => state.genericModalText,
};

const genericModal = {
    state,
    getters,
    mutations,
};

export default genericModal;
